/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M18.25 24a.75.75 0 0 0 .75-.75v-3a.7607.7607 0 0 0-.0036-.0743C20.7099 19.8297 22 18.3155 22 16.5s-1.2901-3.3297-3.0036-3.6757A.7607.7607 0 0 0 19 12.75v-12a.75.75 0 0 0-1.5 0v12c0 .0251.0012.0498.0036.0743-1.7135.346-3.0036 1.8602-3.0036 3.6757s1.2901 3.3297 3.0036 3.6757a.7607.7607 0 0 0-.0036.0743v3a.75.75 0 0 0 .75.75ZM5.0036 3.8243C3.2901 4.1703 2 5.6845 2 7.5s1.2901 3.3297 3.0036 3.6757A.7575.7575 0 0 0 5 11.25v12a.75.75 0 0 0 1.5 0v-12a.7575.7575 0 0 0-.0036-.0743C8.2099 10.8297 9.5 9.3155 9.5 7.5S8.2099 4.1703 6.4964 3.8243A.7598.7598 0 0 0 6.5 3.75v-3a.75.75 0 0 0-1.5 0v3c0 .025.0012.0498.0036.0743Z"
    clipRule="evenodd"
  />,
  'MenuPropertiesFilled'
);
